
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Cookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { BindReportGrid, ReverseFormatDate, exportToExcel, formatDate, setFocus, setTitle } from "../Common/Common";
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { getCommonData } from '../Common/CommanServices';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";
import Loader from '../Layout/Loader';

const StockMovementReport = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode');
    const WarehouseName = cookies.get('warehouseName');
    const WarehouseCode = cookies.get('warehouseCode')
    const [salesPerson, setSalesPerson] = useState([]);
    const [ItemNoData, setItemNoData] = useState([]);
    const [MenuText, setMenuText] = useState("Stock Movement Report");
    const [tableData, setTableData] = useState({})
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [FilterData, setFilterData] = useState({
        PageIndex: "1",
        WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        ItemNo: "",
        FromDate: "",
        ToDate: ""
    });
    const [WareHouse, setWarehouseData] = useState([]);
    useEffect(() => {
        setTitle('StockMovementReport', setOpen);
        setFocus('txtWarehouse');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

   // useEffect(() => {
       /// getStockMovementData();
   // }, [FilterData.PageIndex]);

    const getStockMovementData = async (Type = 'S', PI = FilterData?.PageIndex || "1") => {

        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Report/ShowExStockMovementReport`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'StockMovementReport');

                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData({});
            }
            setIsLoading(false)
        })
    }

    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
                SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
                ItemNo: "",
                FromDate: "",
                ToDate: ""
            }
        );
        setTableData({});
        getStockMovementData();
        setFocus('txtWareHouse');
    }

    const searchHandle = async () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        getStockMovementData();
    }

    const handleDownloadExcel = async () => {
        getStockMovementData('E');
    }
    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }
    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };

    const getWareHouse = () => {
        setWarehouseData([]);
        let temp = {
            Type: "GetWareHouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let WareHouseData = res.autoCompleteData || [];
                setWarehouseData(WareHouseData);
            } else {
                console.error("Error fetching Ware house data:", res.message);
                setWarehouseData([]);
            }
        });
    };
    let WareHouseArr = []
    for (let i = 0; i < WareHouse.length; i++) {
        let mydata = WareHouse[i]?.values
        WareHouseArr.push(mydata)
    };
    const handleChange1 = (event, value) => {
        getStockMovementData("S", value);
        console.log(value)
    };

    const getItemNo = () => {
        setItemNoData([])
        let temp = {
            Type: "GetItemNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let itemData = res.autoCompleteData || [];
                setItemNoData(itemData);
            } else {
                setItemNoData([]);
            }
        });
    }
    let ItemNoArr = []
    for (let i = 0; i < ItemNoData.length; i++) {
        let mydata = ItemNoData[i]?.values
        ItemNoArr.push(mydata)
    };

    let SalesPersonArr = []
    for (let i = 0; i < salesPerson.length; i++) {
        let mydata = salesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };

    useEffect(() => {
        if (FilterData.FromDate) {
            const fromDateObj = new Date(FilterData.FromDate);
            const toDateObj = new Date(FilterData.ToDate);

            if (
                !FilterData.ToDate ||
                toDateObj <= fromDateObj
            ) {
                const nextDay = new Date(fromDateObj);
                nextDay.setDate(fromDateObj.getDate() + 1);

                const formattedNextDay = formatDate(nextDay);

                setFilterData(prev => ({
                    ...prev,
                    ToDate: formattedNextDay
                }));
            }
        }
    }, [FilterData.FromDate]);

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtSalesPerson") };
                                                }}
                                                label='Ware House'
                                                placeholder="Ware House"
                                                maxLength='50'
                                                disabled={WarehouseCode ? true : false}
                                                options={WareHouseArr}
                                                id='txtWareHouse'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getWareHouse()}
                                                inputValue={FilterData.WareHouse ? FilterData.WareHouse : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('WareHouse', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtItem") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={FilterData.SalesPerson ? FilterData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('SalesPerson', newInputValue)

                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtFromDate") };
                                                }}
                                                label='Item No'
                                                placeholder="Item No"
                                                maxLength='50'
                                                options={ItemNoArr}
                                                id='txtItem'
                                                ignore_common={true}
                                                onFocus={() => getItemNo()}
                                                inputValue={FilterData.ItemNo ? FilterData.ItemNo : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('ItemNo', newInputValue)
                                                }}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">From Date</label>
                                            <div className="row">
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.FromDate) || null}
                                                        id='txtFromDate'
                                                        className="form-control"
                                                        placeholderText='From Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, FromDate: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtFromDate')
                                                            };
                                                        }}
                                                        maxDate={new Date()}
                                                    /></div>
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.ToDate) || null}
                                                        id='txtToDate'
                                                        className="form-control"
                                                        placeholderText='To Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, ToDate: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('btnSearch')
                                                            };
                                                        }}
                                                        minDate={new Date(FilterData.FromDate) || null}
                                                    /></div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}

                                            >
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} handleChange1={handleChange1} currentPageNo={currentPageNo} />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </main>
    )
}
export default StockMovementReport